/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityProviderEntity
 */
export interface IdentityProviderEntity {
    /**
     * 認証プロバイダーがデフォルトかカスタムか判別
     * @type {string}
     * @memberof IdentityProviderEntity
     */
    type: IdentityProviderEntityTypeEnum;
    /**
     * サードパーティID
     * @type {string}
     * @memberof IdentityProviderEntity
     */
    thirdPartyId: string;
    /**
     * 認証プロバイダー名
     * @type {string}
     * @memberof IdentityProviderEntity
     */
    name: string;
    /**
     * クライアントID
     * @type {string}
     * @memberof IdentityProviderEntity
     */
    clientId?: string;
    /**
     * クライアントシークレット
     * @type {string}
     * @memberof IdentityProviderEntity
     */
    clientSecret?: string;
    /**
     * OIDCディスカバリーエンドポイント
     * @type {string}
     * @memberof IdentityProviderEntity
     */
    oidcDiscoveryEndpoint?: string;
    /**
     * OAuth Scope
     * @type {Array<string>}
     * @memberof IdentityProviderEntity
     */
    scope?: Array<string>;
}


/**
 * @export
 */
export const IdentityProviderEntityTypeEnum = {
    Default: 'default',
    Custom: 'custom'
} as const;
export type IdentityProviderEntityTypeEnum = typeof IdentityProviderEntityTypeEnum[keyof typeof IdentityProviderEntityTypeEnum];


/**
 * Check if a given object implements the IdentityProviderEntity interface.
 */
export function instanceOfIdentityProviderEntity(value: object): value is IdentityProviderEntity {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('thirdPartyId' in value) || value['thirdPartyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IdentityProviderEntityFromJSON(json: any): IdentityProviderEntity {
    return IdentityProviderEntityFromJSONTyped(json, false);
}

export function IdentityProviderEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'thirdPartyId': json['thirdPartyId'],
        'name': json['name'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'oidcDiscoveryEndpoint': json['oidcDiscoveryEndpoint'] == null ? undefined : json['oidcDiscoveryEndpoint'],
        'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function IdentityProviderEntityToJSON(json: any): IdentityProviderEntity {
    return IdentityProviderEntityToJSONTyped(json, false);
}

export function IdentityProviderEntityToJSONTyped(value?: IdentityProviderEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'thirdPartyId': value['thirdPartyId'],
        'name': value['name'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'oidcDiscoveryEndpoint': value['oidcDiscoveryEndpoint'],
        'scope': value['scope'],
    };
}

